/* eslint-disable no-nested-ternary */
import React from 'react';
import {
  Typography700,
  ExpandableDescriptionV2,
  Carousel,
  ImgBox,
} from 'views/rebranded-module/common/components';
import { Box, Typography } from '@mui/material';
import StyledBox from 'views/rebranded-module/tours-module/TourViewV2/components/ItineraryIItem/ItineraryIItem.styles';
import Youtube from 'react-lazyload-youtube';
import 'react-lazyload-youtube/dist/index.css';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';
import { useSelector } from 'react-redux';

const ItineraryIItem = (props) => {
  const { activity, sameDayTour, cmsData } = props;
  const { isCrawler } = useSelector((state) => state.globalData);
  const renderMedia = () => {
    if (activity.assets?.length > 1 && !isCrawler) {
      return (
        <Carousel
          deskTopItems={1}
          tabletItem={1}
          desktopPartialVisibilityGutter="0"
          mobilePartialVisibilityGutter="0"
          tabletPartialVisibilityGutter="0">
          {activity.assets?.map((asset) => (
            <Box
              height="100%"
              key={asset.youtube_video_id || asset.image.medium_url}>
              {asset.youtube_video_id ? (
                <Youtube
                  videoId={asset.youtube_video_id}
                  height="100%"
                  width="100%"
                  imgSize="maxresdefault"
                />
              ) : (
                <ImgBox
                  image={{
                    src: asset.image.medium_url,
                    alt: activity.title,
                  }}
                  width="100%"
                  height="100%"
                  objectFit="cover"
                  unoptimized
                />
              )}
            </Box>
          ))}
        </Carousel>
      );
    }

    const asset = activity.assets?.[0];

    if (
      (activity.assets?.length === 1 || isCrawler)
      && asset?.image?.medium_url
    ) {
      return (
        <ImgBox
          image={{
            src: asset.image.medium_url,
            alt: activity.title,
          }}
          width="100%"
          height="100%"
          layout="fill"
          objectFit="cover"
          unoptimized
        />
      );
    }

    if (asset?.youtube_video_id) {
      return (
        <Youtube
          videoId={asset.youtube_video_id}
          height="100%"
          width="100%"
          imgSize="maxresdefault"
        />
      );
    }

    return (
      <ImgBox
        image={{
          src: '/imgs/Rebranding/logos/default.jpg',
          alt: activity.title,
        }}
        width="100%"
        height="100%"
        layout="fill"
        objectFit="cover"
      />
    );
  };

  return (
    <StyledBox>
      <Box className="IIImageSectionContainer">{renderMedia()}</Box>
      {!sameDayTour && (
        <Typography700 component="p" variant="overline2" color="primary" mb={2}>
          {`day ${activity.day}`}
        </Typography700>
      )}

      <Typography700 component="p" variant="h5" mb={2.25}>
        {activity.title}
        {!sameDayTour && (
          <>
            {activity.start && ` - ${cmsData.TourDetailsPage.arrival}`}
            {activity.end && ` - ${cmsData.TourDetailsPage.departure}`}
          </>
        )}
      </Typography700>

      {!sameDayTour && (
        <Typography className="IIDistanceDisplay">
          {interpolateString(cmsData.TourDetailsPage.distanceDisplay, {
            miles: activity.distance.miles,
            km: activity.distance.km,
          })}
        </Typography>
      )}
      <ExpandableDescriptionV2
        content={cmsData.ExpandableSectionComponent}
        description={activity.description}
        collapsedSize={72}
      />
    </StyledBox>
  );
};

export { ItineraryIItem };
